/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */

import { Fragment, useState } from "react";

// react-router components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Icon from "@mui/material/Icon";
import Popper from "@mui/material/Popper";


import Divider from "@mui/material/Divider";
import MuiLink from "@mui/material/Link";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import NavbarDropdown from "./NavbarDropdown";
import logo from "assets/images/Spechs_logo/logo_no_text_transparent.png";
import scrollToTop from "../utils/scrollToTop";
import colors from "assets/theme/base/colors";

const accentColors = {
  property: colors.gradients.info.state,
  cleaning: colors.gradients.success.state,
};

function Navbar({ brand, routes, transparent, light, relative, center, section }) {
  const accent = accentColors[section] || accentColors.property;
  const [dropdown, setDropdown] = useState("");
  const [dropdownEl, setDropdownEl] = useState("");
  const [dropdownName, setDropdownName] = useState("");
  const [nestedDropdown, setNestedDropdown] = useState("");
  const [nestedDropdownEl, setNestedDropdownEl] = useState("");
  const [nestedDropdownName, setNestedDropdownName] = useState("");



  const renderNavbarItems = routes.map(({ name, icon, route, collapse }) => (
    <NavbarDropdown
      key={name}
      name={name}
      icon={icon}
      route={route}
      collapse={Boolean(collapse)}
      onClick={() => scrollToTop()}
      onMouseEnter={({ currentTarget }) => {
        if (collapse) {
          setDropdown(currentTarget);
          setDropdownEl(currentTarget);
          setDropdownName(name);
        }
      }}
      onMouseLeave={() => collapse && setDropdown(null)}
      light={light}
      accentColor={accent}
    />
  ));

  // Render the routes on the dropdown menu
  const renderRoutes = routes.map(({ name, collapse, columns, rowsPerColumn }) => {
    let template;

    // Render the dropdown menu that should be display as columns
    if (collapse && columns && name === dropdownName) {
      const calculateColumns = collapse.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / rowsPerColumn);

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = [];
        }

        resultArray[chunkIndex].push(item);

        return resultArray;
      }, []);

      template = (
        <MKBox key={name} display="flex" py={1} px={1.5}>
          {calculateColumns.map((cols, key) => (
            <MKBox key={key} sx={{ position: "relative", pr: key < calculateColumns.length - 1 ? 1 : 0, pl: key !== 0 ? 1 : 0 }}>
              {key !== 0 && (
                <Divider
                  orientation="vertical"
                  sx={{ position: "absolute", top: "50%", left: -16, transform: "translateY(-45%)", height: "90%" }}
                />
              )}
              {cols.map((col, index) => (
                <Fragment key={col.name}>
                  <MKTypography
                    component={col.route ? Link : MuiLink}
                    to={col.route ? col.route : ""}
                    onClick={() => scrollToTop()}
                    display="block"
                    variant="button"
                    fontWeight="bold"
                    textTransform="capitalize"
                    py={1}
                    px={0.5}
                    mt={index !== 0 ? 2 : 0}
                    sx={{ cursor: "pointer", whiteSpace: "nowrap" }}
                  >
                    {col.name}
                  </MKTypography>
                  {col.collapse &&
                    col.collapse.map((item) => (
                      <MKTypography
                        key={item.name}
                        component={item.route ? Link : MuiLink}
                        to={item.route ? item.route : ""}
                        onClick={() => scrollToTop()}
                        href={item.href ? item.href : (e) => e.preventDefault()}
                        target={item.href ? "_blank" : ""}
                        rel="noreferrer"
                        display="block"
                        variant="button"
                        color="text"
                        textTransform="capitalize"
                        fontWeight="regular"
                        py={0.625}
                        px={2}
                        sx={({ palette: { grey }, borders: { borderRadius } }) => ({
                          borderRadius: borderRadius.md,
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                          transition: "color 300ms linear, background-color 300ms linear",
                          "&:hover": {
                            backgroundColor: grey[200],
                            color: `${accent} !important`,
                          },
                        })}
                      >
                        {item.name}
                      </MKTypography>
                    ))}
                </Fragment>
              ))}
            </MKBox>
          ))}
        </MKBox>
      );

      // Render the dropdown menu that should be display as list items
    } else if (collapse && name === dropdownName) {
      template = collapse.map((item) => {
        const linkComponent = {
          component: MuiLink,
          href: item.href,
          target: "_blank",
          rel: "noreferrer",
        };

        const routeComponent = {
          component: Link,
          to: item.route,
        };

        return (
          <MKTypography
            key={item.name}
            {...(item.route ? routeComponent : linkComponent)}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            variant="button"
            textTransform="capitalize"
            minWidth={item.description ? "14rem" : "12rem"}
            color={item.description ? "dark" : "text"}
            fontWeight={item.description ? "bold" : "regular"}
            py={item.description ? 1 : 0.625}
            px={2}
            data-text={item.name}
            sx={({ palette: { grey }, borders: { borderRadius } }) => ({
              borderRadius: borderRadius.md,
              cursor: "pointer",
              transition: "color 300ms linear, background-color 300ms linear",

              "&:hover": {
                backgroundColor: grey[200],
                color: `${accent} !important`,
                "& *": { color: accent },
              },
            })}
            onMouseEnter={({ currentTarget }) => {
              if (item.dropdown) {
                setNestedDropdown(currentTarget);
                setNestedDropdownEl(currentTarget);
                setNestedDropdownName(item.name);
              }
            }}
            onMouseLeave={() => {
              if (item.dropdown) {
                setNestedDropdown(null);
              }
            }}
            onClick={() => scrollToTop()}
          >
            {item.description ? (
              <MKBox>
                {item.name}
                <MKTypography
                  display="block"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                  sx={{ transition: "all 300ms linear" }}
                >
                  {item.description}
                </MKTypography>
              </MKBox>
            ) : (
              item.name
            )}
            {item.collapse && (
              <Icon
                fontSize="small"
                sx={{ fontWeight: "normal", verticalAlign: "middle", mr: -0.5 }}
              >
                keyboard_arrow_right
              </Icon>
            )}
          </MKTypography>
        );
      });
    }

    return template;
  });

  // Routes dropdown menu
  const dropdownMenu = (
    <Popper
      anchorEl={dropdown}
      popperRef={null}
      open={Boolean(dropdown)}
      placement="bottom-start"
      style={{ zIndex: 10 }}
      modifiers={[{ name: "arrow", enabled: false }]}
      onMouseEnter={() => setDropdown(dropdownEl)}
      onMouseLeave={() => {
        if (!nestedDropdown) {
          setDropdown(null);
          setDropdownName("");
        }
      }}
    >
      {() => (
        <MKBox>
          <MKBox shadow="lg" borderRadius="lg" p={1} mt={1} sx={{ background: "white", width: "max-content" }}>
            {renderRoutes}
          </MKBox>
        </MKBox>
      )}
    </Popper>
  );

  // Render routes that are nested inside the dropdown menu routes
  const renderNestedRoutes = routes.map(({ collapse, columns }) =>
    collapse && !columns
      ? collapse.map(({ name: parentName, collapse: nestedCollapse }) => {
          let template;

          if (parentName === nestedDropdownName) {
            template =
              nestedCollapse &&
              nestedCollapse.map((item) => {
                const linkComponent = {
                  component: MuiLink,
                  href: item.href,
                  target: "_blank",
                  rel: "noreferrer",
                };

                const routeComponent = {
                  component: Link,
                  to: item.route,
                };

                return (
                  <MKTypography
                    key={item.name}
                    {...(item.route ? routeComponent : linkComponent)}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    variant="button"
                    textTransform="capitalize"
                    minWidth={item.description ? "14rem" : "12rem"}
                    color={item.description ? "dark" : "text"}
                    fontWeight={item.description ? "bold" : "regular"}
                    py={item.description ? 1 : 0.625}
                    px={2}
                    sx={({ palette: { grey, dark }, borders: { borderRadius } }) => ({
                      borderRadius: borderRadius.md,
                      cursor: "pointer",
                      transition: "all 300ms linear",

                      "&:hover": {
                        backgroundColor: "grey[200]",
                        color: dark.main,

                        "& *": {
                          color: dark.main,
                        },
                      },
                    })}
                  >
                    {item.description ? (
                      <MKBox>
                        {item.name}
                        <MKTypography
                          display="block"
                          variant="button"
                          color="text"
                          fontWeight="regular"
                          sx={{ transition: "all 300ms linear" }}
                        >
                          {item.description}
                        </MKTypography>
                      </MKBox>
                    ) : (
                      item.name
                    )}
                    {item.collapse && (
                      <Icon
                        fontSize="small"
                        sx={{ fontWeight: "normal", verticalAlign: "middle", mr: -0.5 }}
                      >
                        keyboard_arrow_right
                      </Icon>
                    )}
                  </MKTypography>
                );
              });
          }

          return template;
        })
      : null
  );

  // Dropdown menu for the nested dropdowns
  const nestedDropdownMenu = (
    <Popper
      anchorEl={nestedDropdown}
      popperRef={null}
      open={Boolean(nestedDropdown)}
      placement="right-start"
      style={{ zIndex: 10 }}
      onMouseEnter={() => {
        setNestedDropdown(nestedDropdownEl);
      }}
      onMouseLeave={() => {
        setNestedDropdown(null);
        setNestedDropdownName("");
        setDropdown(null);
      }}
    >
      {() => (
        <MKBox ml={2.5} mt={-2.5} borderRadius="lg">
          <MKBox shadow="lg" borderRadius="lg" py={1.5} px={1} mt={2} sx={{ background: "white" }}>
            {renderNestedRoutes}
          </MKBox>
        </MKBox>
      )}
    </Popper>
  );

  return (
    <Container
      style={{
        width: "100%",
        height: "auto",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        // backgroundColor: "rgba(255, 255, 255, 0.8)",
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      {/* {brand} */}
      <MKBox
        p={0}
        m={0}
        width="80%"
        height="auto"
        shadow={transparent ? "none" : "md"}
        // color={light ? "white" : "dark"}
        position={relative ? "relative" : "absolute"}
        left={0}
        right={0}
        sx={{
          // backdropFilter: transparent ? "none" : `saturate(200%) blur(30px)`,
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          padding: "10px 20px",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          // borderBottom: `3px solid ${accent}`,
        }}
      >
        <MKBox display="flex" justifyContent="space-between" alignItems="center">
          <MKBox
            component={Link}
            to="/"
            lineHeight={1}
            py={transparent ? 1.5 : 0.75}
            pl={0}
            onClick={() => scrollToTop()}
          >
            <MKTypography variant="button" fontWeight="bold" color={light ? "white" : "dark"}>
              {brand}
            </MKTypography>
          </MKBox>
          <MKBox
            color="inherit"
            display={{ xs: "none", lg: "flex" }}
            ml="auto"
            mr={center ? "auto" : 0}
            sx={{ cursor: "pointer" }}
          >
            {renderNavbarItems}
          </MKBox>
        </MKBox>
      </MKBox>
      {dropdownMenu}
      {nestedDropdownMenu}
    </Container>
  );
}

// Setting default values for the props of DefaultNavbar
Navbar.defaultProps = {
  brand: (
    <div style={{ display: "flex", alignItems: "center" }}>
      <img src={logo} alt="Logo" style={{ height: "32px", marginRight: "10px" }} />
    </div>
  ),
  routes: [],
  transparent: false,
  light: false,
  sticky: false,
  relative: false,
  center: false,
  section: "property",
};

// Typechecking props for the DefaultNavbar
Navbar.propTypes = {
  brand: PropTypes.node,
  routes: PropTypes.arrayOf(PropTypes.shape).isRequired,
  transparent: PropTypes.bool,
  light: PropTypes.bool,
  sticky: PropTypes.bool,
  relative: PropTypes.bool,
  center: PropTypes.bool,
  section: PropTypes.oneOf(["property", "cleaning"]),
};

export default Navbar;
